
const constants = {
    BASE_URL: "https://hn.algolia.com/api/v1/",
    NUMBER_OF_ITEMS: 10,

};
Object.freeze(constants);

export default constants;